import PropTypes from "prop-types";
import { Button } from "components/Common/MatchInfo/sub/MatchInfoButtonGroup";
import { useEffect, useState } from "react";

export function Tabs({ tabList, activeIndex }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    activeIndex(index);
  }, [index, setIndex, activeIndex]);

  return (
    <div style={{ display: "flex", flexDirection: "row" }}>
      {tabList?.map((item, idx) => (
        <Button
          key={Math.random(999)}
          title={item.title}
          setActive={() => setIndex(idx)}
          active={index === idx}
        />
      ))}
    </div>
  );
}
Tabs.propTypes = {
  activeIndex: PropTypes.func.isRequired,
  tabList: PropTypes.arrayOf(
    PropTypes.shape({
      map: PropTypes.func,
    }),
  ).isRequired,
};
